import { render, staticRenderFns } from "./itinerary_air_base.vue?vue&type=template&id=6219e697&"
import script from "./itinerary_air_base.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260304115753/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6219e697')) {
      api.createRecord('6219e697', component.options)
    } else {
      api.reload('6219e697', component.options)
    }
    module.hot.accept("./itinerary_air_base.vue?vue&type=template&id=6219e697&", function () {
      api.rerender('6219e697', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_base.vue"
export default component.exports